import { render } from "./ChatGLMBotSettings.vue?vue&type=template&id=5f213291"
import script from "./ChatGLMBotSettings.vue?vue&type=script&lang=js"
export * from "./ChatGLMBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__